import {useMutation} from '@apollo/react-hooks';

import type {VerifyPhoneNumber, VerifyPhoneNumberVariables} from 'nutshell-graphql-types';

import VERIFY_PHONE_NUMBER from '../mutations/verify-phone-number.graphql';

export function useVerifyPhoneNumber() {
    const [verifyPhoneNumber, {loading, error}] = useMutation<
        VerifyPhoneNumber,
        VerifyPhoneNumberVariables
    >(VERIFY_PHONE_NUMBER);

    return {
        verifyPhoneNumber: (phoneNumber: string) => {
            return verifyPhoneNumber({
                variables: {phoneNumber},
            });
        },
        loading,
        error,
    };
}
